module.exports = __webpack_public_path__ + "GothamBook.f30e83b96507ecc32937.woff";


//////////////////
// WEBPACK FOOTER
// /Users/vijay/projects/customers-app/src/assets/fonts/gotham/GothamBook.woff
// module id = ../../../../../src/assets/fonts/gotham/GothamBook.woff
// module chunks = styles